/* eslint-disable */
import React from "react";
import { CalendarMonth } from '../../../controls/CalendarMonth';
import { CalendarHierarchy, InputCalendarHierarchyItem } from '../../../controls/CalendarHierarchy';
import { ICalendarItem, useDictionary, useParameter } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { equal, uniq } from "../../../../../shared";

export const IndexEndHierarchyControl: React.FC = () => {
    const [controlItems, setControlItems] = React.useState<InputCalendarHierarchyItem[] | undefined>();
    const [dictItems] = useDictionary(dictionaryService, "calendar-origin");
    const [calendarValue, setCalendarValue] = useParameter<number>("@index_end");
    const [startValue, setStartValue] = useParameter<number>("@index_start");
    const [yearFrequency, monthFrequency, weekFrequency] = [1, 4, 7];

    React.useEffect(function updateControlsItemsByDictionaryItems() {
        const candiatesControlItems = dictItems?.map<InputCalendarHierarchyItem & { frequency: number }>(item => ({
            id: Number(item.id),
            parent: item.getValue<number>('parent'),
            name: item.getValue<string>('name') || '',
            frequency: item.getValue<number>('frequencyId')!,
        }));

        const [minYear, maxYear] = [120000101, Number(`1${new Date().getFullYear()}0101`)];
        const nextControlItems = candiatesControlItems?.reduce((result, item) => {
            if (item.frequency !== weekFrequency) {
                const itemId = item.id as number;
                if (item.frequency === yearFrequency && itemId >= minYear && itemId <= maxYear) {
                    result.push(item);
                } else if (item.frequency === monthFrequency) {
                    const paretQuartal = dictItems?.find(dictItem => equal(+dictItem.id, item.parent));
                    const parentYearId = paretQuartal?.getValue<number>('parent')!;
                    if (parentYearId >= minYear && parentYearId <= maxYear) {
                        item.parent = parentYearId;
                        result.push(item);
                    }
                }
            }
            return result;
        }, [] as typeof candiatesControlItems);

        setControlItems(nextControlItems);
    }, [JSON.stringify(dictItems)]);

    const handlerChange = React.useCallback((value: unknown) => {
        const montheOrYearId = [value as number[] | number].flat()[0] as number;
        setCalendarValue(montheOrYearId);
        if (!startValue || +String(montheOrYearId).slice(1,7) < +String(startValue).slice(1,7)) {
            setStartValue(montheOrYearId);
        }
    }, [dictItems, startValue]);

    return <CalendarHierarchy selectableParent label="Index end date" value={calendarValue} onChange={handlerChange} items={controlItems} />;
};
